import { ArrowUpRight, Mail } from "lucide-react";

const LOGO = "/logo-initial.png";
const EMAIL = "inquiries@cameronbergsma.com";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-black text-white overflow-hidden"
    >
      {/* Soft top edge glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(220,38,38,0.55) 50%, transparent 100%)",
        }}
      />

      <div className="relative mx-auto max-w-[1760px] px-6 md:px-12 lg:px-16 py-12 md:py-14 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        {/* Brand */}
        <div className="flex items-center gap-4">
          <img
            src={LOGO}
            alt=""
            draggable={false}
            className="w-10 h-10 object-contain shrink-0 select-none"
            data-testid="footer-logo"
          />
          <div className="flex flex-col">
            <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-white/45">
              Cameron Bergsma
            </span>
            <span
              className="font-script italic mt-0.5 leading-[1] text-2xl"
              style={{
                background:
                  "linear-gradient(180deg, #ffffff 0%, #FCA5A5 50%, #DC2626 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                WebkitTextFillColor: "transparent",
                color: "transparent",
                paddingBottom: "0.1em",
              }}
            >
              Mr. Possible
            </span>
          </div>
        </div>

        {/* Links */}
        <nav className="flex items-center gap-x-6 gap-y-2 flex-wrap">
          <a
            href="/publications"
            data-testid="footer-link-publications"
            className="group inline-flex items-center text-sm md:text-base text-white/75 hover:text-white transition-colors"
          >
            <span className="relative">
              Publications
              <span
                aria-hidden
                className="pointer-events-none absolute left-0 -bottom-0.5 h-[1.5px] w-0 bg-[#DC2626] transition-all duration-300 ease-out group-hover:w-full"
                style={{ boxShadow: "0 0 8px rgba(220,38,38,0.6)" }}
              />
            </span>
          </a>
          <a
            href="https://aikarotech.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-link-aikarotech"
            className="group inline-flex items-center gap-1 text-sm md:text-base text-white/75 hover:text-white transition-colors"
          >
            <span className="relative">
              Aikarotech.com
              <span
                aria-hidden
                className="pointer-events-none absolute left-0 -bottom-0.5 h-[1.5px] w-0 bg-[#DC2626] transition-all duration-300 ease-out group-hover:w-full"
                style={{ boxShadow: "0 0 8px rgba(220,38,38,0.6)" }}
              />
            </span>
            <ArrowUpRight className="h-3.5 w-3.5 opacity-40 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
          </a>
          <a
            href="https://eamico.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-link-eamico"
            className="group inline-flex items-center gap-1 text-sm md:text-base text-white/75 hover:text-white transition-colors"
          >
            <span className="relative">
              Eamico.com
              <span
                aria-hidden
                className="pointer-events-none absolute left-0 -bottom-0.5 h-[1.5px] w-0 bg-[#DC2626] transition-all duration-300 ease-out group-hover:w-full"
                style={{ boxShadow: "0 0 8px rgba(220,38,38,0.6)" }}
              />
            </span>
            <ArrowUpRight className="h-3.5 w-3.5 opacity-40 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="footer-link-email"
            className="group inline-flex items-center gap-1.5 text-sm md:text-base text-white/75 hover:text-white transition-colors"
          >
            <Mail className="h-3.5 w-3.5 text-[#FCA5A5]" />
            <span className="relative">
              {EMAIL}
              <span
                aria-hidden
                className="pointer-events-none absolute left-0 -bottom-0.5 h-[1.5px] w-0 bg-[#DC2626] transition-all duration-300 ease-out group-hover:w-full"
                style={{ boxShadow: "0 0 8px rgba(220,38,38,0.6)" }}
              />
            </span>
            <ArrowUpRight className="h-3.5 w-3.5 opacity-40 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
          </a>
        </nav>

        {/* Copyright */}
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/35">
          © {new Date().getFullYear()} · Mr. Possible
        </span>
      </div>
    </footer>
  );
}
